import { Box } from '@mui/material';
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import ChartTooltip from '../chartTooltip';

export default function Sparkline({
  data,
  color,
  height = 44,
  showDots = true,
  shaded = true,
  gradientId = 'sparklineGradient',
  tooltipValueFormatter,
  tooltipLabelName,
}) {
  const normalizedData = (data || []).map((value, index) => ({
    index,
    value,
  }));

  return (
    <Box sx={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={normalizedData}
          margin={{
            top: 5,
            right: 3,
            bottom: 1,
            left: 3,
          }}
        >
          <defs>
            <linearGradient
              id={gradientId}
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
              <stop
                offset="0%"
                stopColor={color}
                stopOpacity={0.22}
              />

              <stop
                offset="100%"
                stopColor={color}
                stopOpacity={0}
              />
            </linearGradient>
          </defs>

          <Tooltip
            content={({ active, payload }) => (
              <ChartTooltip
                active={active}
                payload={payload}
                disableLabel
                valueFormatter={tooltipValueFormatter}
                labelName={tooltipLabelName}
              />
            )}
          />

          <Area
            type="linear"
            dataKey="value"
            stroke={color}
            strokeWidth={1.5}
            fill={
              shaded
                ? `url(#${gradientId})`
                : 'transparent'
            }
            fillOpacity={1}
            isAnimationActive={false}
            dot={
              showDots
                ? {
                  r: 2,
                  fill: color,
                  stroke: '#ffffff',
                  strokeWidth: 1,
                }
                : false
            }
            activeDot={
              showDots
                ? {
                  r: 3,
                  fill: color,
                  stroke: '#ffffff',
                  strokeWidth: 1,
                }
                : false
            }
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
}
